var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { Screen, toggleModalAction } from '@banking/ui/workflows/debit-card-activation';
import { CardData, ListCardsRequest } from '@square/dashboard-protos/models/squareup/bizbank/service';
import { DebitCardActivationUpsellRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/v1/client_service';
import assert from '@banking/ui/utils/assert';
const SERVICE_REGISTRY_KEY = 'debit-card-activation-upsell';
let DebitCardActivationUpsell = (_class = class DebitCardActivationUpsell extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "upsellTitle", _descriptor, this);
    _initializerDefineProperty(this, "buttonTitle", _descriptor2, this);
    _initializerDefineProperty(this, "cards", _descriptor3, this);
    _initializerDefineProperty(this, "unitTokens", _descriptor4, this);
    _initializerDefineProperty(this, "features", _descriptor5, this);
    _initializerDefineProperty(this, "bbFrontendClientApi", _descriptor6, this);
    _initializerDefineProperty(this, "bizbankApi", _descriptor7, this);
    _initializerDefineProperty(this, "debitCardActivationModal", _descriptor8, this);
    _initializerDefineProperty(this, "sentry", _descriptor9, this);
  }
  async fetchActivatableCards(activatableCards) {
    const unitTokensToCardTokens = activatableCards.reduce((acc, activatableCard) => {
      const {
        unitToken,
        activatableCardToken
      } = activatableCard;
      assert(unitToken, 'Missing unit token from activatable card');
      assert(activatableCardToken, 'Missing card token from activatable card');
      if (acc[unitToken]) {
        return acc;
      }
      return {
        ...acc,
        [unitToken]: activatableCardToken
      };
    }, {});
    const unitToCardTokenEntries = Object.entries(unitTokensToCardTokens);
    const activatablePhysicalCardData = await Promise.all(unitToCardTokenEntries.map(([unitToken, cardToken]) => this.getActivatablePhysicalCardData(unitToken, cardToken)));
    return unitToCardTokenEntries.reduce((acc, [unitToken], index) => {
      const cardData = activatablePhysicalCardData[index];
      if (cardData) {
        return {
          ...acc,
          [unitToken]: cardData
        };
      }
      return acc;
    }, {});
  }
  async getActivatablePhysicalCardData(unitToken, cardToken) {
    const response = await this.bizbankApi.client.listCards(ListCardsRequest.create({
      unitToken
    }));
    const {
      cards
    } = response;
    return cards.find(card => card.cardToken === cardToken && card.cardType === CardData.CardType.PHYSICAL && card.isActivatable);
  }
  async fetch(unitTokens) {
    try {
      const {
        upsellTitle,
        buttonTitle,
        activatableCards
      } = await this.bbFrontendClientApi.client.getDebitCardActivationUpsell(DebitCardActivationUpsellRequest.create({
        unitTokens
      }));
      this.upsellTitle = upsellTitle;
      this.buttonTitle = buttonTitle;
      this.cards = await this.fetchActivatableCards(activatableCards);
      this.unitTokens = Object.keys(this.cards);
    } catch (error) {
      this.sentry.captureException(error);
    }
  }
  doesUnitHaveActivatableCard(unitToken) {
    return Boolean(this.cards[unitToken]);
  }
  openCardActivationModal(unitToken) {
    const card = this.cards[unitToken];
    assert(card);
    this.debitCardActivationModal.emit(toggleModalAction(true, unitToken, card));
  }
  closeCardActivationModal() {
    // FIXME(cvu): figure out a better way to call `fetch` once card is activated successfully
    if (this.debitCardActivationModal.currentScreen === Screen.SUCCESS) {
      this.fetch(this.unitTokens);
    }
    this.debitCardActivationModal.emit(toggleModalAction(false));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "upsellTitle", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "buttonTitle", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cards", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "unitTokens", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendClientApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "bizbankApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "debitCardActivationModal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DebitCardActivationUpsell as default };